import { registerComponent } from "lib/components";
import { BigqueryQueryJobsStatsViewerApp } from "./main";

registerComponent({ BigqueryQueryJobsStatsViewerApp });
